import { render } from "./HotkeyItem.vue?vue&type=template&id=5b3c737e"
import script from "./HotkeyItem.vue?vue&type=script&lang=js"
export * from "./HotkeyItem.vue?vue&type=script&lang=js"

import "./HotkeyItem.vue?vue&type=style&index=0&id=5b3c737e&lang=css"
script.render = render

export default script